module.exports = __webpack_public_path__ + "static/media/steering-wheel.0619dabd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/steering-wheel.svg
// module id = 3616
// module chunks = 7